import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppMaterialModule } from '../../../../../app-material.module';
import { CardAiMenuComponent } from '../../../../../shared/components/card-ai-menu/card-ai-menu.component';
import { CardSuporteMenuComponent } from '../../../../../shared/components/card-suporte-menu/card-suporte-menu.component';
import { ThemeService } from '../../../../../shared/services/theme.service';
import { V2ShellLayoutStore } from '../../services/v2-shell-layout.store';
import { V2ShellSidebarNavComponent } from '../v2-shell-sidebar-nav/v2-shell-sidebar-nav.component';

@Component({
    selector: 'app-v2-shell-sidebar',
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        AppMaterialModule,
        V2ShellSidebarNavComponent,
        CardAiMenuComponent,
        CardSuporteMenuComponent,
    ],
    templateUrl: './v2-shell-sidebar.component.html',
    styleUrl: './v2-shell-sidebar.component.scss',
})
export class V2ShellSidebarComponent {
    @Input() isAdm = false;
    @Input() habilitarGerenciadorAnuncios = false;

    @Output() closeSidebar = new EventEmitter<void>();
    @Output() toggleAi = new EventEmitter<void>();

    constructor(
        public themeService: ThemeService,
        private layoutStore: V2ShellLayoutStore,
    ) {}

    get isCollapsed(): boolean {
        return this.layoutStore.isDesktop && this.layoutStore.isCollapsed;
    }

    onCloseSidebar(): void {
        this.closeSidebar.emit();
    }

    onToggleAi(): void {
        this.toggleAi.emit();
    }
}
